var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{staticClass:"customHotMap",staticStyle:{"position":"absolute"},style:({height: _vm.height}),attrs:{"span":24}},[_c('div',{staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"baiduMap"}}),_vm._v(" "),_c('ImageOpenDialog',{ref:"markerDialog",attrs:{"dialog-width":_vm.chartConfig.dialogWidth,"currentMarker":_vm.currentMarker}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12a68fbe","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/CustomMapChart3.vue
// module id = 837
// module chunks = 0